import { Flex, Text } from '@chakra-ui/react'
import React from 'react'
import { colorPalette } from '~/themes/colors/colorPalette'

interface InitialsAvatarProps {
  firstName?: string
  lastName?: string
  size?: 'sm' | 'lg'
}

export const InitialsAvatar: React.FC<InitialsAvatarProps> = ({
  firstName = '',
  lastName = '',
  size = 'lg',
}) => {
  const getInitials = () => {
    const trimmedFirstName = firstName?.trim() ?? ''
    const trimmedLastName = lastName?.trim() ?? ''

    const firstInitial = trimmedFirstName.charAt(0).toUpperCase()

    const lastNameParts = trimmedLastName.split(' ')
    const lastInitial = lastNameParts[lastNameParts.length - 1]
      .charAt(0)
      .toUpperCase()

    return `${firstInitial}${lastInitial}`
  }

  const dimensions = size === 'sm' ? '2.5rem' : '6.25rem'

  return (
    <Flex
      w={dimensions}
      h={dimensions}
      minW={dimensions}
      minH={dimensions}
      borderRadius="50%"
      justifyContent="center"
      alignItems="center"
      bg={colorPalette.gray[500]}
    >
      <Text
        fontSize={size === 'sm' ? '0.75rem' : '2rem'}
        fontWeight={size === 'sm' ? '700' : '400'}
      >
        {getInitials()}
      </Text>
    </Flex>
  )
}
